import { uiActionType } from '@/Shared/domain'
import type { UIState } from '@/Shared/ui/navigation'
import { ProtectedNavigationModalProps } from '@/Shared/ui/navigation/atoms/ProtectedNavigationModal'

export type UIAction =
  | { type: uiActionType.openSidebar }
  | { type: uiActionType.closeSidebar }
  | { type: uiActionType.toggleSidebar }
  | { type: uiActionType.openHelper }
  | { type: uiActionType.closeHelper }
  | { type: uiActionType.closingHelper }
  | {
      type: uiActionType.registerNavigationModal
      props: ProtectedNavigationModalProps
    }
  | { type: uiActionType.unregisterNavigationModal }

export function uiReducer(state: UIState, action: UIAction): UIState {
  switch (action.type) {
    case uiActionType.openSidebar: {
      return {
        ...state,
        sidebarCollapsed: false,
      }
    }
    case uiActionType.closeSidebar: {
      return {
        ...state,
        sidebarCollapsed: true,
      }
    }
    case uiActionType.toggleSidebar: {
      return {
        ...state,
        sidebarCollapsed: !state.sidebarCollapsed,
      }
    }
    case uiActionType.openHelper: {
      return {
        ...state,
        helperActive: true,
        helperClosing: false,
      }
    }
    case uiActionType.closeHelper: {
      return {
        ...state,
        helperActive: false,
        helperClosing: false,
      }
    }
    case uiActionType.closingHelper: {
      return {
        ...state,
        helperActive: true,
        helperClosing: true,
      }
    }
    case uiActionType.registerNavigationModal: {
      return {
        ...state,
        protectedNavigationModal: action.props,
      }
    }
    case uiActionType.unregisterNavigationModal: {
      return {
        ...state,
        protectedNavigationModal: null,
      }
    }
    default:
      return state
  }
}
